import React, { useState, useEffect } from 'react';
import {
  Typography,
  CircularProgress,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { showAlert } from '../../store/slices/alertSlice';
import {
  useInventroyDetails,
  useDownloadWholesaleInventory // this should now be a mutation hook
} from './wholesaleinventory.hooks';
import { constants } from '../../constants';

export default function ManageWholesaleLoads() {
  const dispatch = useDispatch();

  // fetch inventory list
  const { data, isLoading, isError, error } = useInventroyDetails();
  const [loadData, setLoadData] = useState(null);

  useEffect(() => {
    if (data) setLoadData(data);
  }, [data]);

  if (isError) {
    dispatch(
      showAlert({
        severity: constants.ERROR,
        title: error?.message || 'Failed to load inventory details.'
      })
    );
  }

  // download inventory (mutation)
  const {
    mutate: downloadInventory,
    isPending: isDownloading,
    isSuccess: downloadIsSuccess,
    data: downloadData,
    error: downloadError
  } = useDownloadWholesaleInventory();

  // handle download success
  useEffect(() => {
    if (downloadIsSuccess && downloadData) {
      const blob = new Blob([downloadData], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'wholesale-inventory.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      dispatch(
        showAlert({
          severity: constants.SUCCESS,
          title: 'The inventory has been successfully downloaded.'
        })
      );
    }
  }, [downloadIsSuccess, downloadData, dispatch]);

  return (
    <>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Wholesale Inventory Details
      </Typography>

      <Button
        variant="contained"
        color="primary"
        onClick={() => downloadInventory()} // trigger mutation
        disabled={isDownloading}
        sx={{ mb: 2 }}
      >
        {isDownloading ? 'Downloading…' : 'Download Inventory'}
      </Button>

      {isLoading ? (
        <CircularProgress />
      ) : (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Product Code</TableCell>
              <TableCell>Name</TableCell>
              <TableCell sx={{ textAlign: 'right' }}>Price</TableCell>
              <TableCell>Quantity</TableCell>
              <TableCell>Sold Quantity</TableCell>
              <TableCell>Inventory Stock</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.isArray(loadData?.inventories) &&
            loadData.inventories.length > 0 ? (
              loadData.inventories.map((item) => (
                <TableRow key={item.id}>
                  <TableCell sx={{ width: 100 }}>{item.productcode}</TableCell>
                  <TableCell>{item.name}</TableCell>
                  <TableCell sx={{ textAlign: 'right' }}>
                    € {item.price}
                  </TableCell>
                  <TableCell>{item.quantity}</TableCell>
                  <TableCell>{item.salesquantity}</TableCell>
                  <TableCell>
                    {item.quantity - (item.salesquantity ?? 0)}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  No products in inventory.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      )}
    </>
  );
}
